export default __webpack_public_path__ + "static/media/whisle.f857a7b6.svg";